/**
 * Formatação para exibição. A aritmética mora em `@tcm/shared/money`.
 */
export {
  formatarBRL,
  formatarValor,
  aplicarMascaraMoeda,
  mascaraParaCentavos,
  formatarTelefoneBR,
  aplicarMascaraTelefone,
  apenasDigitos,
  normalizarTelefone,
} from '@tcm/shared';

const FUSO = 'America/Sao_Paulo';

const dataCurta = new Intl.DateTimeFormat('pt-BR', {
  day: '2-digit',
  month: '2-digit',
  year: 'numeric',
  timeZone: FUSO,
});

const dataHora = new Intl.DateTimeFormat('pt-BR', {
  day: '2-digit',
  month: '2-digit',
  year: 'numeric',
  hour: '2-digit',
  minute: '2-digit',
  timeZone: FUSO,
});

/** ISO → '13/08/2026'. String vazia quando não há data. */
export function formatarData(iso: string | null | undefined): string {
  if (!iso) return '';
  const data = new Date(iso);
  return Number.isNaN(data.getTime()) ? '' : dataCurta.format(data);
}

/** ISO → '13/08/2026 14:22'. */
export function formatarDataHora(iso: string | null | undefined): string {
  if (!iso) return '';
  const data = new Date(iso);
  return Number.isNaN(data.getTime()) ? '' : dataHora.format(data);
}

/** ISO → valor de um `<input type="date">` ('2026-08-13'), no fuso do negócio. */
export function paraInputDate(iso: string | null | undefined): string {
  if (!iso) return '';
  const data = new Date(iso);
  if (Number.isNaN(data.getTime())) return '';
  const partes = new Intl.DateTimeFormat('en-CA', {
    year: 'numeric',
    month: '2-digit',
    day: '2-digit',
    timeZone: FUSO,
  }).format(data);
  return partes;
}

export function hojeInputDate(): string {
  return paraInputDate(new Date().toISOString());
}

/**
 * Capitaliza cada palavra preservando a posição do cursor — mesmo
 * comportamento do `capitalizeWords()` das telas atuais.
 */
export function capitalizarPalavras(texto: string): string {
  return texto.replace(/(^|\s)([a-zà-ú])/g, (_todo, espaco: string, letra: string) =>
    `${espaco}${letra.toUpperCase()}`,
  );
}

/** '5 dias' / '1 dia' / 'hoje' — usado nas bolinhas do monitor. */
export function descreverDias(dias: number | null | undefined): string {
  if (dias == null) return '';
  if (dias <= 0) return 'hoje';
  return dias === 1 ? '1 dia' : `${dias} dias`;
}
